import { ReactElement } from 'react';
import { Alert } from '@mui/material';
import { isEmulatorVersionAtLeast, useLocalstackStatus } from '@localstack/services';
import { LAMBDA_WEB_MIN_VERSION } from '@localstack/constants';
import { LoadingFragment, PageTitle } from '@localstack/ui';

import { LambdaProps } from '../types';

import { NavTabs } from './NavTabs';

type LambdaWebVersionGateProps = LambdaProps & { children: ReactElement };

export const LambdaWebVersionGate = ({
  Layout,
  routes,
  clientOverrides,
  children,
}: LambdaWebVersionGateProps): ReactElement => {
  const { running, version, isLoading } = useLocalstackStatus(clientOverrides);
  const versionMismatch = !isEmulatorVersionAtLeast(version || '', LAMBDA_WEB_MIN_VERSION);
  const alertMessage = !running
    ? 'LocalStack is not running. Start LocalStack to use this feature.'
    : versionMismatch
      ? `This feature requires LocalStack version ${LAMBDA_WEB_MIN_VERSION} or higher.`
      : undefined;
  if (!isLoading && !alertMessage) return children;

  return (
    <Layout
      documentTitle="Lambda: Web Functions"
      title={<PageTitle title="Web Functions" />}
      tabs={<NavTabs routes={routes} />}
    >
      <LoadingFragment loading={isLoading}>
        <Alert severity="info">{alertMessage}</Alert>
      </LoadingFragment>
    </Layout>
  );
};
